module.exports = __webpack_public_path__ + "static/media/tu2.8a3f3479.png";